module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_8023.7c901634.png";